import ReactDOM from 'react-dom';

/**
 * React Portals are a tool that let you render a child-component into someplace other than where the component/DOM
 * hierarchy says you *should* be rendering. You can use this to escape a z-index war or whatever.
 *
 * That's a per-component decision, though - you either return some JSX or you return ReactDOM.createPortal. If you want
 * to render just one thing in a portal, you can wrap it in this component instead.
 *
 * Theoretically we could put shared calculate-positioning-relative-to-JS-parent-instead-of-DOM-parent logic here.
 *
 * @param portalTarget An outside-the-React-tree DOM node that we're gonna Portal into.
 * @param children The content that you want to throw into the Portal.
 */
export let PortalWrapper = ({portalTarget, children}) => {
    return ReactDOM.createPortal(children, portalTarget);
}
